
export const ITEM_TYPES = {
    REGULAR: "regular",
    CONSIGNMENT: "consignment",
    SPECIAL: "special"
}
